import React, { useEffect, useState, createContext, useContext } from 'react';
import WelcomePopup from './WelcomePopup';

/**
 * WelcomePopupContext - Provides global access to show the welcome popup
 */
const WelcomePopupContext = createContext();

export const useWelcomePopup = () => useContext(WelcomePopupContext);

/**
 * WelcomePopupProvider - Wraps the app and handles showing the welcome popup
 * Checks sessionStorage for pending welcome popup after login
 */
export const WelcomePopupProvider = ({ children }) => {
    const [showPopup, setShowPopup] = useState(false);
    const [clubData, setClubData] = useState(null);

    // Check for pending welcome popup on mount and on navigation
    useEffect(() => {
        const checkForWelcomePopup = () => {
            const shouldShow = sessionStorage.getItem('showWelcomePopup');
            const pendingClub = sessionStorage.getItem('pendingWelcomeClub');

            if (shouldShow === 'true' && pendingClub) {
                try {
                    const club = JSON.parse(pendingClub);
                    setClubData(club);
                    setShowPopup(true);

                    // Clear the flags so it doesn't show again
                    sessionStorage.removeItem('showWelcomePopup');
                    sessionStorage.removeItem('pendingWelcomeClub');

                    console.log('🎉 Showing welcome popup for club:', club.name);
                } catch (error) {
                    console.error('Error parsing club data for welcome popup:', error);
                    sessionStorage.removeItem('showWelcomePopup');
                    sessionStorage.removeItem('pendingWelcomeClub');
                }
            }
        };

        // Check on initial mount
        checkForWelcomePopup();

        // Also check periodically (for cases where user navigates after login)
        const interval = setInterval(checkForWelcomePopup, 500);

        // Clear interval after 5 seconds to avoid unnecessary checks
        setTimeout(() => clearInterval(interval), 5000);

        return () => clearInterval(interval);
    }, []);

    const handleClosePopup = () => {
        setShowPopup(false);
        setClubData(null);
    };

    // Method to manually trigger the popup
    const showWelcomePopup = (club) => {
        setClubData(club);
        setShowPopup(true);
    };

    return (
        <WelcomePopupContext.Provider value={{ showWelcomePopup }}>
            {children}

            {/* Global Welcome Popup */}
            {showPopup && clubData && (
                <WelcomePopup
                    clubName={clubData.name}
                    locationString={clubData.locationString}
                    welcomeMessage={clubData.welcomeMessage}
                    onClose={handleClosePopup}
                    autoDismissMs={6000}
                />
            )}
        </WelcomePopupContext.Provider>
    );
};

export default WelcomePopupProvider;
